export default __webpack_public_path__ + "static/media/circlediagram.93dfe352.svg";